import type { ShareAuthCheckData, ShareOwnerData } from '../types';

export const ShareAuthApi = Symbol('ShareAuthApi');

export interface ShareAuthApi {
    shareAccessCheckForGuest(inData?: ShareAuthCheckData): Promise<boolean>
    shareAccessCheck(inData?: ShareAuthCheckData): Promise<boolean>
    getShareOwnerInfo(inData: ShareAuthCheckData): Promise<ShareOwnerData>
}
